import React, { useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { UploadSimple, CircleNotch } from "@phosphor-icons/react";

export function ImageUpload({ value, onChange, accept = "image/*", label = "Upload image", testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success(`Uploaded ${data.filename}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  const showPreview = value && accept.startsWith("image");
  return (
    <div className="flex items-center gap-3">
      {showPreview && <img src={value} alt="preview" className="h-10 w-10 rounded-md border border-slate-200 object-cover" data-testid={`${testid}-preview`} />}
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        data-testid={testid}
        className="flex items-center gap-2 rounded-md border border-dashed border-slate-300 px-4 py-2 text-xs font-semibold text-slate-600 transition-colors hover:border-teal hover:text-teal disabled:opacity-50"
      >
        {busy ? <CircleNotch size={15} className="animate-spin" /> : <UploadSimple size={15} weight="bold" />}
        {busy ? "Uploading…" : label}
      </button>
      <input ref={inputRef} type="file" accept={accept} onChange={upload} className="hidden" data-testid={`${testid}-input`} />
    </div>
  );
}
